import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Attachment } from '../../../types';
import { loadAttaches } from '../thunks/attaches.thunk';
import { loadChatbotStartChat } from '../thunks/chatbotStartChat.thunk';
import { fieldActions } from './field';
import { IAttachesState, IAttachmentError } from './types';

const initialState: IAttachesState = {
  attachments: [],
  isLoading: false,
};

export const attachesSlice = createSlice({
  name: 'attaches',
  initialState,
  reducers: {
    removeAttachment: (state, action) => {
      return {
        ...state,
        attachments: state.attachments.filter((i) => i.url !== action.payload),
      };
    },
    updateAttachment: (state, action: PayloadAction<Attachment>) => {
      return {
        ...state,
        attachments: state.attachments.map((attachment) =>
          attachment.url !== action.payload.url ? attachment : action.payload,
        ),
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAttaches.pending, (state, action) => {
      const loadingFilesCount = action.meta.arg.files.length;

      return {
        ...state,
        isLoading: true,
        loadingFilesCount,
      };
    });

    builder.addCase(loadAttaches.fulfilled, (state, action) => {
      return {
        ...state,
        attachments: [...state.attachments, ...action.payload],
        isLoading: false,
        loadingFilesCount: 0,
      };
    });

    builder.addCase(loadAttaches.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        loadingFilesCount: 0,
      };
    });

    builder.addCase(fieldActions.sendMessage, (state) => {
      return {
        ...state,
        attachments: [],
      };
    });

    builder.addCase(loadChatbotStartChat.fulfilled, (state, action) => {
      const { ui } = action.payload;

      return {
        isLoading: false,
        attachments: ui && Array.isArray(ui.attachments) ? ui.attachments : [],
      };
    });
  },
});
